import { PageHero } from "@/components/common/PageHero";
import { Reveal } from "@/components/common/Reveal";
import { SectionHeading } from "@/components/common/Primitives";
import { ServicesGrid, GreenBrownfield, ExecutionTimeline, MaterialHandling, ContactBand } from "@/components/home/Sections";
import { useSeo } from "@/hooks/useSeo";
import { IMAGES, INFRA_SERVICES } from "@/data/site";

export default function InfraProjects() {
  useSeo({
    title: "AutoMex Infra Projects | Turnkey Industrial Projects & PEB Contractor Pune",
    description: "AutoMex Infra Projects: industrial infrastructure, PEB, turnkey industrial projects, factory expansion, brownfield projects and industrial construction in Pune.",
    path: "/infra-projects",
  });
  return (
    <>
      <PageHero
        overline="AutoMex Infra Projects"
        title="From Factory Plan to Production."
        subtitle="Coordinated industrial infrastructure and project execution for manufacturing facilities, expansions and industrial developments."
        image={IMAGES.peb}
        crumb="Infra Projects"
      />
      <section className="py-24 md:py-32 bg-white">
        <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
          <Reveal className="mb-12 flex justify-center">
            <img src="/logos/automex-infra-horizontal.png" alt="AutoMex Infra Projects — Driving Industrial Evolution" className="h-28 md:h-36 w-auto object-contain" />
          </Reveal>
          <Reveal>
            <SectionHeading
              overline="Capabilities"
              title="Industrial Infrastructure, Engineered."
              subtitle="A single point of coordination across civil, structures, utilities and machinery integration."
            />
          </Reveal>
          <div className="mt-14"><ServicesGrid services={INFRA_SERVICES} columns={4} /></div>
        </div>
      </section>
      <GreenBrownfield />
      <ExecutionTimeline />
      <MaterialHandling />
      <ContactBand />
    </>
  );
}
